import { initializePopovers } from "../../Shared/Popover/popover";

const tooltips = document.querySelectorAll<HTMLElement>("[data-tooltip]");

tooltips?.forEach(tooltip => initializePopovers(tooltip));
